import { inlineLinkVariants } from "../inline-link/inline-link-styles";

const DEFAULT_PRIVACY_POLICY_HREF = "https://www.assetwatch.com/privacy-policy";

export interface FooterProps {
  /** Copyright year. Defaults to the current year. */
  year?: number;
  /** Destination for the Privacy Policy link. */
  privacyPolicyHref?: string;
  /** Visible link text, which consuming apps may localize. */
  privacyPolicyLabel?: string;
}

function FooterLink({ href, label }: { href: string; label: string }) {
  return (
    <a
      className={inlineLinkVariants({ size: "xs", variant: "contextual" })}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {label}
    </a>
  );
}

/** Compact global footer. Its parent provides the spacing above it. */
export function Footer({
  year = new Date().getFullYear(),
  privacyPolicyHref = DEFAULT_PRIVACY_POLICY_HREF,
  privacyPolicyLabel = "Privacy Policy",
}: FooterProps) {
  return (
    <footer className="flex h-(--spacing-32) w-full items-center justify-start gap-(--spacing-8)">
      <span className="font-(family-name:--font-family-title) text-(length:--font-size-title-xs) leading-(--font-line-height-16) font-(number:--font-weight-regular) text-text-default">
        © {year} AssetWatch
      </span>
      <span
        aria-hidden="true"
        className="h-(--spacing-16) border-l border-outline-subtle"
      />
      <FooterLink href={privacyPolicyHref} label={privacyPolicyLabel} />
    </footer>
  );
}
